{
    "work_email": "Work Email",
    "password": "Password",
    "new_password": "New password",
    "confirmPassword": "Confirm password",
    "confirm_new_password": "Confirm new password",
    "per_page_option": "Show {{rows}} rows",
    "message": "Message",
    "find_sub_company": "Search for a company",
    "fallback_approver": "Fallback approver",
    "request": {
        "document_type": {
            "label": "Document type",
            "invoice": "Invoice",
            "credit_note": "Credit note"
        },
        "self_issued_receipt": {
            "label": "Self-issued receipt",
            "reason": {
                "label": "Reason for self-issued receipt",
                "values": {
                    "lost": "I lost the receipt",
                    "not_received": "I never received a receipt"
                }
            },
            "accurate_information": "I confirm that I will provide the accurate information.",
            "receipt_unobtainable": "I confirm the original receipt couldn't be obtained."
        },
        "kind": "Expense type",
        "name": "Name",
        "link": "Subscription URL",
        "currency": "Currency",
        "monthly_price": "Monthly cost",
        "quarterly_price": "Quarterly Cost",
        "yearly_price": "Yearly cost",
        "description": "Description",
        "performance_date": "Performance date",
        "date_started": "Started on",
        "date_cancellation_due": "contract renews on",
        "billing_period": "Subscription interval",
        "item_name": "Item name",
        "total_price": "Total",
        "quantity": "Quantity",
        "line_items": "Line items",
        "unit_of_measure": "Unit",
        "unit_price": "Unit price",
        "cost_center": "Cost center 1",
        "vendor": "Vendor",
        "approval_needed_by": "Approver",
        "requested_by": "Requested by",
        "invoice": "Invoice",
        "delivery_note": "Delivery note",
        "invoice_number": "Invoice number",
        "invoice_date": "Invoice date",
        "invoice_due_date": "Invoice due on",
        "subscription": "Subscription",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "yearly": "Yearly",
        "tax": "VAT",
        "tax_rate": "VAT (%)",
        "date_paid_at": "Paid on",
        "expense_account": "Expense account",
        "payment_option": "Payment option",
        "offer": "Offer",
        "total_net_amount": "Total net",
        "total_tax": "Total VAT",
        "total_gross_amount": "Total gross",
        "net_unit_price": "Net unit price",
        "total_net": "Net",
        "quantity_short": "Qty.",
        "execution_date": "Execution date",
        "due_on_extra": "Due on: {{dueOn}}",
        "workflow": "Workflow",
        "next_approver": "Next approver",
        "recurring_expense_approval_process": "Approval process for recurring requests",
        "net_price": "Net",
        "gross_price": "Gross",
        "tax_price": "VAT",
        "date": "Date",
        "billable": "Billable",
        "mileage": {
            "return_from_destination": "Return from destination",
            "invoice_number": "Internal receipt number",
            "date": "Date of mileage",
            "vehicle": "Vehicle",
            "vehicle_type": {
                "car": "Car",
                "motorcycle": "Motorcycle"
            },
            "distance": "Distance",
            "start_address": "Start address",
            "destination_address": "Destination address",
            "reason": "Description/Trip reason",
            "total_calculated_amount": "Total calculated amount",
            "additional_stop": "Additional stop",
            "additional_stop_x": "{{nth}} additional stop",
            "additional_distance_reason": "Additional distance reason"
        },
        "per_diem": {
            "breakfast": "Breakfast",
            "lunch": "Lunch",
            "dinner": "Dinner",
            "accommodation": "Accommodation",
            "destination": "Destination",
            "nth_destination": "{{nth}} destination",
            "start_date": "Start date",
            "return_date": "Return date",
            "transfer_date": "Transfer date",
            "time": "Time",
            "start_time": "Start time",
            "return_time": "Return time",
            "transfer_time": "Transfer time",
            "add_destination": "Add additional destination",
            "reason": "Description/Reason for trip"
        },
        "hospitality": {
            "merchant": "Merchant",
            "tip": "Tip",
            "date": "Hospitality date",
            "attendees": "Attendees",
            "reason": "Description/Reason for hospitality"
        },
        "payment_flow_information": {
            "title": "Payment status",
            "not_set": "Not set",
            "already_paid": "Already paid (e.g. SEPA)",
            "already_approved_and_paid": "Already approved & paid",
            "reporting_only": "Reporting only"
        },
        "renewal_generation": {
            "title": "Recurring request generation",
            "by_date": "By date",
            "by_transaction": "By transaction"
        },
        "folder": {
            "trip_date": "Trip date",
            "time": "Time",
            "return_date": "Return date",
            "destination": "Destination",
            "folder_name": "Folder name"
        },
        "subscriptions": {
            "paused": "Paused subscriptions",
            "active": "Active subscriptions"
        }
    },
    "vendor": {
        "name": "Vendor name (short)",
        "nameExtended": "Vendor name (extended)",
        "rating": "Rating",
        "description": "Description",
        "recommendation": "Recommendation",
        "street_name": "Street name",
        "street_number": "Street number",
        "zip": "ZIP",
        "city": "City",
        "country": "Country",
        "country_code": "Country code",
        "contact_person_name": "Contact person name",
        "contact_person_email": "Contact person email",
        "contact_person_phone": "Contact person phone",
        "tax_number": "Tax number",
        "vat_number": "VAT number",
        "iban": "IBAN",
        "bic": "BIC",
        "account_number": "Account number",
        "sort_code": "Sort code",
        "company_logo": "Company logo (optional)",
        "creditor_number": "Creditor number",
        "recommendations": {
            "fine": "Fine",
            "blacklisted": "Blacklisted"
        }
    },
    "employee": {
        "has_system_rights": "System administrator rights",
        "company": "Company",
        "first_name": "First name",
        "last_name": "Last name",
        "email": "Email",
        "location": "Location",
        "work_phone": "Work phone",
        "profile_picture": "Profile picture",
        "position": "Position",
        "personioTooltip": "This information has been fetched from Personio.",
        "team": "Team",
        "role": "Role",
        "superior": "Superior",
        "date_of_birth": "Date of birth",
        "hired_date": "Hired on",
        "limit": "Up to",
        "approver": "Approver",
        "roles": {
            "employee": "Employee",
            "approver": "Approver",
            "admin": "Admin"
        },
        "mileage_rate": "Special mileage rate (ct/km)",
        "show_add_user_to_company_fields": "Add user to company and send invitation email"
    },
    "employee_absence": {
        "period": "Absence period"
    },
    "cost_center": {
        "name": "Cost center 1",
        "id": "Cost center 1 ID",
        "responsible_user": "Responsible employee",
        "shared_users": "Share with",
        "shared_with": "Shared with",
        "shared_users_all_option_label": "All",
        "shared_users_people_counter_label": "People",
        "default_budget_value": "Default budget",
        "alternative_budget": "Alternative budget",
        "default_budget_currency": "Budget currency",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "yearly": "Yearly",
        "budget_value": "Budget value",
        "budget_period": "Budget period",
        "budget": {
            "status": "Spending compared to budget",
            "above_budget": "Above budget",
            "within_budget": "Within budget"
        }
    },
    "cost_center_filter": {
        "starting_date": "Starting date",
        "ending_date": "Ending date"
    },
    "settings": {
        "global_currency": "Global currency",
        "show_expense_numbers": "Show expense numbers",
        "enable_ocr": "Enable OCR",
        "enable_ocr_itemization": "Enable OCR itemization",
        "enable_go_to_next_expense": "Approval: Navigation to next expense",
        "enable_email_notifications": "Enable email notifications",
        "show_gross": "Show gross amounts",
        "ocr": "OCR",
        "inline_items": "Inline items",
        "archiveAfterXDays": "Archive automatically after (days)",
        "role_name": "Profile name",
        "archiveExpensesAfterXDays": "Archive expenses automatically after (days)",
        "archiveTransactionsAfterXDays": "Archive transactions automatically after (days)",
        "csv_delimiter": "CSV delimiter",
        "number_separator": "CSV decimal separator",
        "show_stamp": "Show stamp",
        "default_role_profile": "Select a default profile as a basis for your custom profile"
    },
    "company_settings": {
        "po_skip_procurement": "Skip Procurement Approval for Purchase Orders",
        "logo": "Company logo",
        "name": "Company name",
        "companyIdentifier": "Company Identifier",
        "bic": "BIC",
        "iban": "IBAN",
        "default_creditor_number": "Default creditor number",
        "default_employee_creditor_number": "Default employee creditor number",
        "card_feature": "Card feature",
        "liquidity_management_feature": "Liquidity feature",
        "auto_match_feature": "Auto transaction matching",
        "allow_cost_center_2_creation": "Allow cost center 2 creation",
        "allow_workflow_adjustments": "Allow workflow adjustments",
        "is_lexware_export_enabled": "Lexware CSV export",
        "is_non_sepa_xml_export_enabled": "NON SEPA XML export",
        "is_sepa_xml_bulgaria_enabled": "SEPA XML (Bulgaria)",
        "add_audit_trail_to_invoice_export": "Generate audit trail as additional file with invoice",
        "address_line": "Street name and number",
        "city": "City",
        "country": "Country code (two letters, e.g. DE)",
        "zip": "ZIP",
        "sameAsBusinessAddress": "Same as business address",
        "tagging_feature": "Tagging feature",
        "allow_all_to_update_absences": "Everybody can update their absences",
        "enable_edit_rights": "Enable tag edit rights for all",
        "payment_flow_information": {
            "already_approved_and_paid": "\"Already approved & paid\" process",
            "already_paid": "\"Already paid\" process",
            "reporting_only": "\"Reporting only\" process"
        },
        "show_cost_centers_ids": "Show cost center 1 IDs in all drop down menus",
        "vendor_rules_should_overwrite": "Vendor rules override employee rules",
        "vendor_creation_for_all": "Vendor creation for all users",
        "show_auto_approver_warning": "Auto approver warning",
        "invoice_auto_match_feature": "Auto matching of inbox invoices",
        "distance_buffer": "Distance buffer in kilometers (km)",
        "recalculate_approval_process_after_amount_changes": "Recalculate approval processes of requests on amount changes",
        "recalculate_approval_process_after_folder_amount_changes": "Recalculate approval processes of folders on amount changes",
        "recalculate_approval_process_after_other_changes": "Recalculate approval process of requests on other changes",
        "recalculate_approval_process_after_folder_other_changes": "Recalculate approval process of folders on other changes",
        "multi_currency_wallet": "Multi currency wallet",
        "enforce_belegfunktion": "Enforce GoBD-compliance",
        "timezone": "Time zone",
        "default_employee_language": "Default employee language",
        "update_sepa_version": "SEPA xml Version (pain.001.001.09)",
        "vendor_payment_netting": "Vendor payment netting",
        "is_skr42_enabled": "SKR42 (associations)"
    },
    "export": {
        "payment": "Payment",
        "only_paid_requests": "Only paid requests",
        "only_all_docs": "Only requests with all docs",
        "start_date": "Start Date",
        "end_date": "End Date",
        "format": "Format",
        "date_filter": "Date filter",
        "change_history": {
            "resource": "Resource",
            "period": "Change history period"
        },
        "export_format": {
            "all_formats": "All formats",
            "all": "All formats",
            "lexware_csv": "Lexware CSV",
            "csv_lexware": "Lexware CSV",
            "csv": "CSV",
            "change_history": "Change history",
            "datev_invoice_csv": "DATEV Invoice CSV",
            "datev": "DATEV XML",
            "invoices": "Invoices",
            "datev_online": "DUO",
            "sepa": "SEPA-XML",
            "non_sepa": "NON-SEPA-XML",
            "mark_as_done": "Mark as done",
            "audit_trail": "Audit trail",
            "internal_receipt": "Internal receipt"
        }
    },
    "banking": {
        "search_term": "Search term",
        "payment_account": "Payment account",
        "default_connection": "Default connection",
        "custom_name": "Bank name",
        "bank_account": "Bank account",
        "yes": "Yes",
        "no": "No",
        "amounts_mismatch": {
            "title": "Accounting discrepancy detected",
            "checkbox": "The accounting entries in this request do not adhere to standard accounting principles. The NET, TAX, and GROSS values do not align correctly. Do you still wish to approve this transaction?"
        }
    },
    "expense_account": {
        "account_name": "Name",
        "account_code": "Code"
    },
    "cost_center_2": {
        "name": "Name",
        "code": "ID"
    },
    "filter_form": {
        "amount": "Amount",
        "budget": "Budget",
        "min_amount": "Min",
        "max_amount": "Max",
        "time_interval": "Time interval",
        "from": "From",
        "to": "To",
        "all": "All",
        "vendor": "Vendor",
        "team": "Team",
        "role": "Role",
        "not_set": "Not set",
        "date_purchased": "Performance date",
        "due_date": "Due date",
        "due_in_days": "Due in",
        "days": "days",
        "starting_date": "starting date",
        "ending_date": "ending date",
        "iban": "IBAN",
        "description": "Description",
        "probability_range": "Probability",
        "min_probability": "Min probability",
        "max_probability": "Max probability",
        "cost_center": "Cost center 1",
        "cost_center_2": "Cost center 2",
        "expense_account": "Expense account",
        "billing_period": "Billing period",
        "card_attached": "Card attached",
        "card_program_enrolled": "Enrolled in card program",
        "tfa_enabled": "2 Factor Authentication enabled",
        "phone_number_verified": "Phone number verified",
        "superior_set": "Superior set",
        "payment_data_added": "Payment data added",
        "expenses_so_far": "Expenses so far",
        "vendor_rules_set": "Vendor rules set",
        "contract_set": "Contract set",
        "tax_set": "Tax set",
        "vat_set": "VAT set",
        "recommendation": "Recommendation set",
        "creditor_number_range": "Creditor number range",
        "status": "Status"
    },
    "card_filter": {
        "cardType": "Type",
        "mode": "Mode",
        "card_holder": "Card holder",
        "limit": "Limit range",
        "status": "Status",
        "window": "Card frequency",
        "subscription_attached": "Subscription attached",
        "team": "Cardholder team"
    },
    "expense_filter": {
        "kind": "Expense type",
        "cost_center": "Cost center 1",
        "cost_center_2": "Cost center 2",
        "expense_account": "Expense Account",
        "time_interval": "Time interval",
        "min_date": "From",
        "max_date": "To",
        "requester": "Requester",
        "expenseTags": "Tag",
        "status": "Status",
        "date_range": "Date range",
        "date_paid_at": "Paid on",
        "purchase_date_range": "Performance date range",
        "invoice_date_range": "Invoice date range",
        "starting_date": "Starting date",
        "ending_date": "Ending date",
        "approver": "Approver",
        "export_format": {
            "title": "Export format",
            "csv": "Exported as CSV (incl. all format)",
            "not_csv": "Not exported as CSV (excl. all format)",
            "datev_xml": "Exported to DATEV XML",
            "not_datev_xml": "Not exported to DATEV XML",
            "datev_invoice_csv": "Exported as DATEV Invoice CSV",
            "not_datev_invoice_csv": "Not exported as DATEV Invoice CSV",
            "datev_online": "Exported to DUO",
            "not_datev_online": "Not exported to DUO",
            "all_datev": "Exported to DUO or DATEV XML",
            "not_all_datev": "Not exported to DUO and DATEV XML"
        },
        "comments_and_mentions": {
            "title": "Comments & Mentions",
            "my_comments": "My comments",
            "my_mentions": "My mentions"
        },
        "include_archived": "Include archived requests",
        "billable": {
            "title": "Billable",
            "true": "Yes",
            "false": "No"
        },
        "self_issued_receipt": {
            "title": "Self-issued receipt"
        }
    },
    "inbox_filter": {
        "min_upload_date": "From",
        "max_upload_date": "To",
        "uploaded_by": "Uploaded by",
        "not_set": "Not set",
        "upload_date_range": "Upload date range"
    },
    "transaction_filter": {
        "transaction_date_range": "Transaction date range",
        "transaction_status": "Transaction status",
        "transaction_matched": "Matching status",
        "transaction_type": "Transaction type",
        "bank_account": "Bank account"
    },
    "reporting_filter": {
        "cost_center": "Cost center 1",
        "min_date": "From",
        "max_date": "To",
        "date_range": "Date range",
        "purchase_date_range": "Performance date range",
        "invoice_date_range": "Invoice date range",
        "starting_date": "Starting date",
        "ending_date": "Ending date"
    },
    "employee_filter": {
        "min_expenses": "Min expenses",
        "max_expenses": "Max expenses"
    },
    "matching": {
        "expense_id": "Expense ID",
        "csv": {
            "csv_name": "CSV name",
            "change_sign": "Change sign",
            "mapping": {
                "amount": "Amount",
                "date": "Date",
                "description": "Description",
                "description_and_iban": "Description (+ IBAN)",
                "vendor": "Vendor",
                "iban": "IBAN",
                "currency": "Currency",
                "none": "-"
            },
            "amount_option": {
                "title": "Which amounts should be considered",
                "negative": "Negative",
                "positive": "Positive",
                "all": "All"
            }
        }
    },
    "kyb": {
        "company_name": "Company name",
        "trading_name": "Company trading name",
        "establishment_date": "Date of establishment",
        "tax_id": "Tax ID",
        "incorporation_type": "Incorporation type",
        "incorporation_state": "State of incorporation",
        "incorporation_certificate": "Certificate of incorporation",
        "is_public": "Is public or not",
        "yes": "Yes",
        "no": "No",
        "is_payment_provider": "Is payment provider",
        "primary_contact_email": "Email of primary contact",
        "primary_contact_phone": "Mobile number of primary contact",
        "address_company": "Address of the company",
        "address_office": "Office address",
        "street": "Street",
        "street_number": "Street number",
        "city": "City",
        "state": "State",
        "postal_code": "Postal Code",
        "country_code": "Country Code",
        "legal_structure_chart": "Legal structure chart",
        "financial_statement": "Financial statement",
        "memorandum": "Memorandum / Article of association",
        "title": "Directors or officers",
        "legal_rep_information": "Legal representative information",
        "first_name": "First name",
        "last_name": "Last name",
        "job_title": "Job title",
        "date_of_birth": "Date of birth",
        "phone": "Phone number",
        "email": "Email address",
        "is_owner": "Is also beneficial owner",
        "owner": "Yes",
        "not_owner": "No",
        "personal_id": "National ID or driver's license",
        "proof_of_address": "Proof of address",
        "proof_of_address_extra": "Eg., bank statement or utility bill. Must be dated within last 3 months.",
        "add": "Add another beneficial owner",
        "remove": "Remove beneficial owner",
        "date_appointed": "Date appointed",
        "nationality": "Nationality",
        "is_beneficial_owner": "Is also beneficial owner",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Address of the legal representative",
        "identification": "Identification of the director",
        "identification_type": "Type of the identification document",
        "identification_value": "ID or passport number",
        "identification_type_id": "National ID",
        "identification_type_passport": "Passport",
        "shareholder_information": "Shareholder information",
        "company_owner_percentage": "Company owner percentage",
        "attester_name": "Attester name",
        "attestation_date": "Attestation date",
        "official_document": "Official or notarized document of share ownership shows the ultimate shareholders",
        "attestation_consent": "Attestation consent",
        "shares_of_company": "Company ownership percentage",
        "wallet_base_currency": "Base currency of wallet and cards",
        "wallet_base_currency_note": "This cannot be changed afterwards. If you are unsure, please ask our support."
    },
    "card": {
        "limit": "Limit",
        "frequency": "Frequency",
        "transaction_limit": "Transaction limit",
        "atm_withdrawals": "ATM withdrawals",
        "cashback_enabled": "Cashback enabled",
        "auto_recharge_enabled": "Auto recharge",
        "card_name": "Card name or description",
        "mode": {
            "mode": "Mode",
            "prepaid_mode": "Prepaid",
            "debit_mode": "Debit"
        },
        "bin_type": {
            "title": "Card configuration",
            "german_bin": "German BIN",
            "bulgarian_bin": "Non-German BIN"
        },
        "limit_change_approver": "Limit change approver",
        "limit_change_amount": "Desired limit amount for this card",
        "limit_change_reason": "Please specify the reason for changing the limit.",
        "delivery_type": {
            "title": "Delivery method",
            "standard_delivery": "Standard",
            "registered_mail": "Tracked & Signed",
            "courier": "Courier",
            "first_class_mail": "Tracked"
        },
        "renewal_generation_for_sub_card": "Recurring expense generation for subscription",
        "should_update_expense_amount_on_card_transaction": "Auto-adjust expense amounts",
        "name_on_card": "Name on the card",
        "cannot_be_changed_after_creation": "Cannot be changed after creation"
    },
    "corporate": {
        "primary_contact_position": "Your position in the company",
        "primary_contact_mobile": "Your mobile number",
        "pin": "Your desired finway PIN",
        "industry_type": "Industry type",
        "source_of_funds": "Source of funds",
        "source_of_funds_other": "Information about other source of funds",
        "enroll_all_admins": "Enroll all admins to the card program."
    },
    "wallet": {
        "amount": "Withdrawal amount",
        "currency": "Currency",
        "beneficiary_name": "Beneficiary name",
        "beneficiary_address": "Beneficiary address",
        "bank_name": "Bank name",
        "bank_address": "Bank address",
        "bank_country": "Bank country",
        "verification_code": "Verification code",
        "description": "Description"
    },
    "tax": {
        "tax_rate": "VAT rate in %",
        "bu_code": "BU code",
        "bu_code_name": "BU name",
        "default": "Default"
    },
    "team": {
        "team_name": "Team name"
    },
    "workflow": {
        "name": "Name",
        "cost_center": "Cost center 1",
        "cost_center_2": "Cost center 2",
        "vendor": "Vendor",
        "user": "Requester",
        "approver": "Approver",
        "responsible_employee": "Cost center 1 responsible",
        "auto_approver": "Auto Approver",
        "superior": "Superior of the requester",
        "requester": "Requester",
        "scope": {
            "all": "All",
            "purchase": "Purchase",
            "invoice": "Invoice",
            "reimbursement": "Reimbursement",
            "scope": "Scope"
        },
        "request_type": {
            "title": "Request type",
            "all": "All",
            "purchase": "Subscriptions / Purchase",
            "subscription": "Subscriptions",
            "invoice": "Invoice",
            "all_reimbursements": "All reimbursements",
            "standard_reimbursement": "Standard reimbursement",
            "reimbursement": "Reimbursement",
            "mileage_reimbursement": "Mileage reimbursement",
            "hospitality_reimbursement": "Hospitality reimbursement",
            "per_diem_reimbursement": "Per Diem reimbursement",
            "trip_folder": "Folder",

            "purchase_order": "Purchase order"
        },
        "trigger": {
            "trigger_type": "Trigger type",
            "trigger_objects": "Trigger objects",
            "requester": "Requester",
            "vendor": "Vendor",
            "cost_center": "Cost center 1",
            "cost_center_2": "Cost center 2",
            "expense_account": "Expense account",
            "amount": "Net amount",
            "amount_greater": "Net amount >",
            "all": "All"
        },
        "operator": {
            "and": "And",
            "or": "Or"
        },
        "condition": {
            "net_amount_bigger": "If net amount >"
        },
        "then": "Then",
        "add_trigger_type": "AND trigger type",
        "expense_type": "Expense type",

        "recalculate_approval_processes_in_progress": "Recalculate approval processes in progress that were built with this workflow. This will reset the approval processes.",
        "recalculate_also_approval_processes_in_progress": "Recalculate also approval processes in progress."
    },
    "liquidity": {
        "scenario": {
            "name": "Scenario name",
            "color": "Scenario color",
            "main": "Main scenario",
            "sub": "Sub-scenario",
            "parent": "Parent scenario"
        },
        "planned_transaction": {
            "onetime": "One-time",
            "recurring": "Recurring",
            "title": "Title",
            "quantity": "Qty.",
            "amount": "Amount",
            "currency": "Currency",
            "category": "Category",
            "start_date": "Start date",
            "end_date": "End date",
            "frequency": "Frequency",
            "monthly": "Monthly",
            "quarterly": "Quarterly",
            "yearly": "Yearly",
            "apply_all": "Apply to all scenarios"
        }
    },
    "payment_settings": {
        "more_than": "More than",
        "monthly_invoices": "monthly invoices"
    },
    "transaction_category": {
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete"
    },
    "archive": {
        "searchPeriod": "Archive period"
    },
    "integrations": {
        "get_my_invoices": {
            "user_id": "GetMyInvoices user ID"
        }
    },
    "passcode": {
        "update": {
            "old_passcode": "Old finway PIN",
            "new_passcode": "New finway PIN"
        }
    },
    "follow_up": "Follow-up",
    "email_alias_for": "Email alias for ",
    "alternative_email_for": "Alternative email for ",
    "csv_settings": {
        "new_template_name": "New Template Name",
        "select_template_name": "Choose existing template to get started faster",
        "field_individualisation": "Field customization",
        "field_add": "Field to add",
        "edit_template_name": "Choose template you want to edit",
        "rename_template": "Rename selected template"
    },
    "custom_bank_subject": {
        "title": "Bank subject line (max 140 characters allowed by SEPA)",
        "invoice_number": "Invoice number",
        "expense_number": "Expense number",
        "vendor_name": "Vendor",
        "description": "Description",
        "request_items": "Request items",
        "not_set": "Not set"
    },
    "data_upload": {
        "errorsList": "Errors",
        "created": "Created",
        "restored": "Restored",
        "ignored": "Ignored",
        "teams": "Teams",
        "employees": "Employees",
        "group_cost_centers": "Group cost centers",
        "cost_centers": "Cost centers",
        "cost_centers_2": "Cost centers 2",
        "expense_accounts": "Expense accounts",
        "vendors": "Vendors",
        "subscriptions": "Subscriptions",
        "history_tab": "Import history",
        "import_tab": "Import data"
    },

    "custom_datev_info": {
        "one_time_no_items": "One time expense (no items) ",
        "one_time_with_items": "One time expense (with items) ",
        "subscriptions": "Subscriptions",
        "reimbursement_no_items": "Reimbursement (no items)",
        "reimbursement_with_items": "Reimbursement (with items)",
        "invoiceNumber": "Invoice number",
        "finwayExpenseNumber": "finway Expense number",
        "vendor": "Vendor",
        "description": "Description",
        "items": "Items",
        "not_set": "Not set",
        "subscriptionName": "Subscription name",
        "employeeName": "Employee name",
        "reimbursementType": "Reimbursement type",
        "expenseType": "Expense type",
        "all_expense": "All expense types",
        "discount": "Discount"
    },
    "sso": {
        "client_id": "Client ID",
        "client_secret": "Client secret",
        "tenant_domain": "Tenant domain"
    },
    "personio": {
        "client_id": "Client ID",
        "client_secret": "Client secret"
    },
    "one_time_expense": "One time expense",
    "subscriptions": "Subscriptions",
    "standard_reimbursement": "Standard reimbursement",
    "hospitality_reimbursement": "Hospitality reimbursement",
    "mileage_reimbursement": "Mileage reimbursement",
    "per_diem_reimbursement": "Per Diem reimbursement",
    "sync_updates": "Sync updates",
    "fiscal_year": {
        "start": "From",
        "end": "To"
    },
    "datev_csv_config": {
        "wallet_account": "finway wallet account",
        "cash_transit_account": "Cash Transit Account",
        "account_length": "Account length"
    },
    "datev_client_and_consultant": {
        "client_number": "Client number",
        "consultant_number": "Consultant number"
    }
}
